import React, {useMemo} from "react";
import Skeleton from "react-loading-skeleton";
import styled, {useTheme} from "styled-components";
import {ProductFilters} from "../../../products/hooks/useProductFiltersParams";
import useProductsList from "../../../products/hooks/useProductsList";
import {SimpleProductsList} from "@ui";
import ProductCard from "src/core/products/components/ProductCard";
import {TitleLabel} from "../components";
import styles from "./productRecommendationsStyles";
import useSite from "src/core/sites/hooks/useSite";

export default function ProductRecommendations({productsInCart}) {
  const filters = useMemo(() => {
    const productSlugs =
      productsInCart && productsInCart.map(product => product.getSlug());
    return new ProductFilters({
      on_sale: "true",
      excludes: productSlugs,
    });
  }, [productsInCart]);

  const {products, meta} = useProductsList({filters, limit: 3, offset: 0});
  const theme = useTheme();
  const site = useSite();

  if (!products || products.getElements().length < 1) return null;

  return (
    <div style={{width: "100%", paddingTop: "20px"}}>
      <TitleLabel>Recommended products just for you!</TitleLabel>
      <Container>
        <SimpleProductsList
          ProductCardComponent={CustomProductCardWrapper}
          maxProducts={{lg: 3, md: 3, sm: 3}}
          products={products ? products.getElements() : []}
          skeleton={meta.loading}
          styles={styles(theme, site)}
        />
      </Container>
    </div>
  );
}

const Container = styled.div`
  .simple-products-list__container {
    padding: ${({theme}) => theme.v2.spacing(4)} 0 ${({theme}) => theme.v2.spacing(4)}
      ${({theme}) => theme.v2.spacing(2)};

    @media (max-width: 428px) {
      padding: ${({theme}) => theme.v2.spacing(4)} ${({theme}) => theme.v2.spacing(1)};
    }
  }

  .simple-products-list__list {
    @media (max-width: 428px) {
      justify-content: flex-start;
    }
  }

  .horizontal-products-list__element {
    &:not(:last-child) {
      margin-right: ${({theme}) => theme.v2.spacing(2)};
    }
  }
`;

const ProductCardWrapper = props => {
  if (props.skeleton) {
    return <Skeleton height={220} />;
  }
  return <ProductCard {...props} mode={"small"} />;
};

const CustomProductCardWrapper = styled(ProductCardWrapper)`
  height: 220px;

  div[class*="ProductCard__ProductPotencyTagsContainer"],
  div[class^="ProductCard__ProductPotencyTagsContainer"],
  span[class*="ProductCard__ProductSize"],
  span[class^="ProductCard__ProductSize"] {
    display: none;
  }

  div[class*="ProductCard__ImageContainer"],
  div[class^="ProductCard__ImageContainer"] {
    min-height: 95px;
  }

  img[class*="ProductCard__ProductImage"],
  img[class^="ProductCard__ProductImage"] {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 95px;
    height: 95px;
  }
`;
